/*!
 * osc-hallerstede
 * Client-side implementation of odoscope for Hallerstede
 * odoscope GmbH - http://www.odoscope.com/
 * Copyright (c) 2025 odoscope GmbH. All rights reserved.
 * Version: 1.3.7
 */

window.oscScriptVersion = '1.3.7';

"osc-hallerstede v1.3.7";

if(!/[?&]noosc/i.test(window.location.search)){(function(){

/**
 * odoscope decision endpoint client library
 * @author odoscope GmbH
 * @version: 1.0
 */
!function(o,n){"use strict";var t="/decisions/configuration",i="/decisions",e=function(){},r=function(o){
return function(n){return function(){return n.apply(o,arguments)}}},c=function(o){
return Array.prototype.slice.call(o)},a=function(o,n){for(var t in o)o.hasOwnProperty(t)&&n(o[t],t);
},u=function(o){return c(arguments).slice(1).forEach(function(n){a(n,function(n,t){
o[t]=n})}),o},s=function(o,n){return function(t){var i;try{i=JSON.parse(t)}catch(e){
return void n.call(this)}o.call(this,i)}},f=function(n,t,i,e){var r;if(r=new XMLHttpRequest,
!("withCredentials"in r)){if(!o.XDomainRequest)return void i();r=new XDomainRequest;
}r.open("GET",n,!0),r.withCredentials=!0,void 0!==e&&(r.timeout=e,r.ontimeout=function(){
i("TIMEOUT")}),r.onerror=function(){i("ERROR")},r.onload=function(){return 200!==r.status?void i():void t(r.responseText);
},r.send()},h=function(o){var n="";return a(o,function(o,t){n+=n.length?"&":"?",n+=Array.isArray(o)?o.map(function(o){
return t+"[]="+encodeURIComponent(o)}).join("&"):t+"="+encodeURIComponent(o)}),n},p={
defaultParams:{},timeout:1e3,maxAge:720,configName:"oscConfiguration",cookiePath:"/",
cookieDomain:null},d=o.Osc=function(o){this._config=u({},p,o)};d.prototype.cookie=function(o,t,i){
if(void 0!==t){void 0===i&&(i=this._config.maxAge);var e=o+"="+encodeURIComponent(JSON.stringify(t));
return[["expires",new Date(Date.now()+36e5*i).toUTCString()],["max-age",3600*i],["path",this._config.cookiePath],["domain",this._config.cookieDomain]].forEach(function(o){
"undefined"!=typeof o[1]&&null!==o[1]&&(e+="; "+o[0]+"="+o[1])}),n.cookie=e,n.cookie.indexOf(o+"=")!==-1?t:void 0;
}var r=o.replace(/[\-+.]/g,"\\$&"),c=new RegExp("(?:^|;)\\s*"+r+"\\s*=\\s*([^;]+)"),a=c.exec(n.cookie);
if(null!==a)try{return JSON.parse(decodeURIComponent(a[1]))}catch(u){}},d.prototype.get=function(o,n,t,i){
var c=r(this),a={token:this._config.token},s=this._config.timeout;u(a,this._config.defaultParams,n);
var p=this._config.base+this._config.tenant+o+h(a);return this.lastDecisionUrl=p,
f(p,c(t),c(i||e),s)},d.prototype.json=function(o,n,t,i){var r=s(t,i||e);return d.prototype.get.call(this,o,n,r,i);
},d.prototype.decision=function(o,n,t){var e;return e=o.returnHTML?d.prototype.get:d.prototype.json,
e.call(this,i,o,n,t)},d.prototype.config=function(o,n){var i,e=r(this);return void 0!==(i=this.cookie(this._config.configName))?void e(o)(i):void this.json(t,{},function(n){
this.cookie(this._config.configName,n),e(o)(n)},n)},d.prototype.dice=function(o,n,t,i,c){
var a,u;void 0===(a=this.cookie(o))?a=this.cookie(o,Math.floor(100*Math.random())):t&&(a=this.cookie(o,a)),
u=void 0!==a&&a<n?i:c||e,r(this)(u)(a)}}(window,document);
(function(window, document) {
    'use strict';

    window.Osc_client = {
        turned_off: true,
        is_control: true
    };

    const ENV = window.Osc_ENV;

    if ( !ENV ) return;
    if ( !ENV.turn_on_osc ) return;


    const SITE_ID        = String(ENV.site_id).trim(),
          DECISION_TOKEN = String(ENV.token).trim(),
          AB_TEST_RATIO  = 100;

    if ( SITE_ID.length == 0 ) return;
    if ( DECISION_TOKEN.length == 0 ) return;

    ENV.ab_test_ratio = AB_TEST_RATIO;


    const navigator = {
        $collectionRE: /(?:\/[\w-]+)?\/collections\/([\w-\d]+)/i,
        $sorting: {
            key: 'sort_by',
            whiteList: new Set([
                'manual',
                'best-selling'
            ])
        },

        get properPathUsed()
        {
            this.$collectionRE.lastIndex = 0;

            return this.$collectionRE.test(window.location.pathname);
        },
        get query()
        {
            return new window.URLSearchParams(window.location.search);
        },
        get sortBy()
        {
            let query = this.query;

            if ( query.has(this.$sorting.key) )
            {
                return query.get(this.$sorting.key);
            }

            return String(ENV.sort_order);
        },
        get isProperSortingUsed()
        {
            return this.$sorting.whiteList.has( this.sortBy );
        }
    };


    if ( !navigator.properPathUsed ) return;


    var oscClient = window.Osc_client = new window.Osc({
        base: "https://odoscope.cloud",
        tenant: "/" + SITE_ID,
        token: DECISION_TOKEN,
        maxAge: 2160,
        timeout: 5000
    });

    oscClient.turned_off = false;
    oscClient.navigator = navigator;
    oscClient.COOKIE_DICE_PREFIX = 'osc-exp-';
    oscClient.COOKIE_TRCK_PREFIX = 'osc-';
    oscClient.TARGET_ID = 'osc-target-container';


    oscClient.dice(oscClient.COOKIE_DICE_PREFIX + DECISION_TOKEN, AB_TEST_RATIO, true,
        function process_odoscope()
        {
            oscClient.is_control = false;
        },
        function process_control()
        {
            oscClient.is_control = true;
        }
    );


    var HIDE_CLASS = 'concealment';

    oscClient.conceal = function()
    {
        document.body.classList.add(HIDE_CLASS);
    };
    oscClient.reveal = function()
    {
        document.body.classList.remove(HIDE_CLASS);
    };
    oscClient.getTargetNode = function()
    {
        return document.getElementById(oscClient.TARGET_ID);
    };


    if ( oscClient.is_control ) return;
    if ( !navigator.isProperSortingUsed ) return;


    (new MutationObserver((mList, observer) =>
        {
            let target = oscClient.getTargetNode();

            if ( target )
            {
                observer.disconnect();

                oscClient.conceal();
            }
        }
    )).observe(
        document,
        {subtree: true, childList: true}
    );

})(window, document);


}).call(this);}
